import React from "react";
import Context from "../../../Context";
import Blocker from "../../Misc/Blocker";
import CrumbsProvider from "../../Misc/CrumbsProvider";
import Scrollpane from "../../Misc/Scrollpane";
import visualState from "../../../visualState";
import ReportItem from "./ReportItem";
import ReportList from "./ReportList";
import ReportTree from "./ReportTree"; 
import ReportTabs from "./ReportTabs";
import ReportRecentList from "./ReportRecentList"; 
import ReportRecentItem from "./ReportRecentItem";
export default class Report extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);

    this.vState = new visualState("ReportSection");

    this.state = {
      pending: false,
      tree: {},
      customListKey: "",
      structureVisible: this.vState.read("structureVisible", true),
    };
  }

  componentDidMount() {
    this.load();
    this.renderButtons();
  }

  componentDidUpdate() {
    this.renderButtons();
  }

  load = async () => {
    this.setState({ pending: true });

    let tree = await this.context.api.qoo(
      `/report/tree/list`,
      { search: [] },
      undefined,
      undefined,
      undefined,
      "node",
      "sequence"
    );

    this.setState({ pending: false, tree });
  };

  toggleVisibleStructure = () => {
    this.setState((state) => {
      this.vState.save({ structureVisible: !state.structureVisible });
      return { structureVisible: !state.structureVisible };
    });
  };

  renderButtons = () => {
    this.context.actionsSet(
      <>
        <button
          title="Отчет на всю ширину"
          onClick={this.toggleVisibleStructure}
          className={`btn btn-icon ${
            !this.state.structureVisible
              ? "bg-light-primary bg-hover-light"
              : "bg-light bg-hover-light-primary"
          }    mr-2`}
        >
          <i className="fa fa-arrows-h"></i>
        </button>
      </>
    );
  };

  render() {
    const { nodeId, itemId, mode, itemMode, recentItemId } = this.props;
    const { tree, pending, structureVisible } = this.state;

    return (
      <>
        <CrumbsProvider title="Отчеты" link="/report/" />
        <Blocker spinnerFixed hAuto on={this.state.pending}>
          <div className="row h-100">
            {structureVisible && (
              <>
                <div className="col-lg-3 border-right no-print">
                  <Scrollpane>
                    <ReportTree
                      items={tree}
                      nodeId={pending ? null : nodeId}
                      itemId={itemId}
                      mode={mode}
                    />
                  </Scrollpane>
                </div>
                <div className="col-lg-3 border-right no-print">
                  <Scrollpane>
                    <ReportList
                      customListKey={this.state.customListKey}
                      {...this.props}
                    />
                  </Scrollpane>
                </div>
              </>
            )}

            <div className="col h-100">
              <Scrollpane>
                {itemId && <ReportTabs {...this.props} />}
                {itemMode === "new" && <ReportItem itemId={itemId} />}
                {itemMode === "recent" && !recentItemId && (
                  <ReportRecentList {...this.props} itemId={itemId} />
                )}
                {itemMode === "recent" && recentItemId && (
                  <ReportRecentItem {...this.props} itemId={itemId} />
                )}
              </Scrollpane>
            </div>
          </div>
        </Blocker>
      </>
    );
  }
}
